import { render, staticRenderFns } from "./AdMetrics.vue?vue&type=template&id=00a5833f"
import script from "./AdMetrics.vue?vue&type=script&lang=js"
export * from "./AdMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports